import React, { useState } from "react";
import { TextField, Button, Box } from "@mui/material";

// Define uncertainty rules as config
const config = [
  { vMin: 1, vMax: 10, fMin: 10, fMax: 200, percent: 0.0014, offset: 0.17 },
  { vMin: 1, vMax: 10, fMin: 200, fMax: 450, percent: 0.0046, offset: 0.17 },
  { vMin: 1, vMax: 10, fMin: 450, fMax: 600, percent: 0.0086, offset: 0.17 },
  { vMin: 10, vMax: 35, fMin: 30, fMax: 200, percent: 0.0011, offset: 0.81 },
  { vMin: 10, vMax: 35, fMin: 200, fMax: 450, percent: 0.007, offset: 0.81 },
  { vMin: 10, vMax: 35, fMin: 450, fMax: 600, percent: 0.015, offset: 0.81 },
  { vMin: 35, vMax: 70, fMin: 30, fMax: 100, percent: 0.0014, offset: 1 },
  { vMin: 35, vMax: 70, fMin: 100, fMax: 450, percent: 0.007, offset: 1 },
  { vMin: 35, vMax: 70, fMin: 450, fMax: 600, percent: 0.03, offset: 1 },
  { vMin: 70, vMax: 100, fMin: 30, fMax: 100, percent: 0.002, offset: 1.3 },
  { vMin: 70, vMax: 100, fMin: 100, fMax: 450, percent: 0.012, offset: 1.3 },
  { vMin: 70, vMax: 100, fMin: 450, fMax: 600, percent: 0.17, offset: 1.3 },
];

function ACHighVoltage() {
  const [voltage, setVoltage] = useState("");
  const [frequency, setFrequency] = useState("");
  const [uncertainty, setUncertainty] = useState("");

  const handleCalculate = () => {
    const v = parseFloat(voltage);
    const f = parseFloat(frequency);
    if (isNaN(v) || isNaN(f)) {
      setUncertainty("Invalid input");
      return;
    }

    const rule = config.find(
      (r) => v >= r.vMin && v <= r.vMax && f >= r.fMin && f <= r.fMax
    );

    if (rule) {
      const result = rule.percent * v * 1000 + rule.offset;
      setUncertainty(`${result.toFixed(2)}`);
    } else {
      setUncertainty("Out of range");
    }
  };

  const handleCopy = () => {
    if (uncertainty && !["Out of range", "Invalid input"].includes(uncertainty)) {
      navigator.clipboard.writeText(uncertainty);
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 400,
        margin: "auto",
        mt: 5,
        p: 3,
        boxShadow: 3,
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <TextField
        label="Enter Voltage (kV)"
        variant="outlined"
        type="number"
        value={voltage}
        onChange={(e) => setVoltage(e.target.value)}
        fullWidth
      />
      <TextField
        label="Enter Frequency (Hz)"
        variant="outlined"
        type="number"
        value={frequency}
        onChange={(e) => setFrequency(e.target.value)}
        fullWidth
      />
      <Button variant="contained" onClick={handleCalculate}>
        Calculate Uncertainty
      </Button>
      <TextField
        label="Uncertainty (V)"
        variant="outlined"
        value={uncertainty}
        InputProps={{ readOnly: true }}
        fullWidth
      />
      <Button
        variant="contained"
        onClick={handleCopy}
        disabled={!uncertainty || ["Out of range", "Invalid input"].includes(uncertainty)}
      >
        Copy
      </Button>
    </Box>
  );
}

export default ACHighVoltage;
